import {
  IconActivity,
  IconAirplane,
  IconBusiness,
  IconConcierge,
  IconDeclined,
  IconDesktop,
  IconDining,
  IconDocument,
  IconInfant,
  IconLaunch,
  IconLounge,
  IconMerchandise,
  IconPhotoId,
  IconPrint,
  IconQrScan,
  IconRefreshment,
  IconSpa,
  IconSparkle,
  IconTelephone,
  IconWifi,
} from '@americanexpress/dls-icons';

export const amenityIdToIconMap = {
  '18_CARDHOLDER': IconPhotoId,
  '21_CARDHOLDER': IconPhotoId,
  'NON-SMOKING': IconDeclined,
  BEER_WINE_FREE: IconRefreshment,
  BEER_WINE: IconRefreshment,
  CHILDREN_ROOMS: IconInfant,
  CLOTHES_PRESS: IconMerchandise,
  CONFERENCE_ROOMS_FREE: IconBusiness,
  CONFERENCE_ROOMS: IconBusiness,
  FLIGHT_MONITORS: IconAirplane,
  INTERNET_TERMINALS: IconDesktop,
  NEWSPAPERS: IconDocument,
  PREMIUM_FOOD_FREE: IconDining,
  PREMIUM_FOOD: IconDining,
  PRINTERS_FREE: IconPrint,
  PRINTERS: IconPrint,
  PRIVATE_ROOMS_FREE: IconLounge,
  PRIVATE_ROOMS: IconLounge,
  SHOWERS_FREE: IconSparkle,
  SHOWERS: IconSparkle,
  SNACKS_FREE: IconDining,
  SNACKS: IconDining,
  SPA_FREE: IconSpa,
  SPA: IconSpa,
  SPIRITS_LIQUOR_FREE: IconRefreshment,
  SPIRITS_LIQUOR: IconRefreshment,
  TELEPHONES: IconTelephone,
  TV: IconDesktop,
  WIFI_FREE: IconWifi,
  WIFI: IconWifi,
  LOUNGEBUDDY_CHECKIN: IconQrScan,
  CLOTHES_PRESS_FREE: IconMerchandise,
  GYM_FREE: IconActivity,
  GYM: IconActivity,
  SHOE_SHINE: IconSparkle,
  SMOKING_ROOMS: IconLounge,
};

export const centurionAmenityIconMap = {
  beer: IconRefreshment,
  chef: IconDining,
  conferenceSpace: IconBusiness,
  droplet: IconRefreshment,
  enter: IconLaunch,
  familyRoom: IconInfant,
  freshSeasonalFare: IconDining,
  healthySnack: IconDining,
  highSpeedWiFi: IconWifi,
  largeFlatScreenTvs: IconDesktop,
  magazinesAndNewspapers: IconDocument,
  memberDeskServices: IconConcierge,
  mug: IconRefreshment,
  openKitchen: IconDining,
  outdoorTerrace: IconLounge,
  phone: IconTelephone,
  powerStations: IconDesktop,
  premiumBar: IconRefreshment,
  printFaxCopy: IconPrint,
  semiprivateWorkspaces: IconBusiness,
  showerSuite: IconSparkle,
  spa: IconSpa,
  teapot: IconRefreshment,
  wineTastingArea: IconRefreshment,
  workspaces: IconBusiness,
  workstation: IconDesktop,
};
